<template>
  <!--
      	作者：zhuchangtao
      	时间：2021-03-30
      	描述：题库-任务列表
      -->
  <div>
     <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
       <el-form-item label="名称/手机号" v-if="task.type ==1 ||task.type ==2 ||task.type ==4 "><el-input size="small" v-model="searchForm.search" placeholder="请输入名称/手机号"></el-input></el-form-item>

       <el-form-item label="类型" v-if="task.type ==3">
         <el-select size="small" v-model="searchForm.unit_id" placeholder="请选择">
           <el-option label="全部" value=""></el-option>
           <el-option v-for="(item, index) in unitList" :key="index" :label="item.unit_name" :value="item.unit_id"></el-option>


         </el-select>
       </el-form-item>
       <el-form-item label="起始时间">
         <div class="block">
           <span class="demonstration"></span>
           <el-date-picker
             size="small"
             v-model="searchForm.create_time"
             type="daterange"
             value-format="yyyy-MM-dd"
             range-separator="至"
             start-placeholder="开始日期"
             end-placeholder="结束日期"
           ></el-date-picker>
         </div>
       </el-form-item>
       <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>

     </el-form>

    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" border v-loading="loading">
        <!-- <el-table-column prop="rank_id" label="ID" width="60"></el-table-column> -->
        <el-table-column v-if="task.type<3" prop="user" label="用户信息">
          <template slot-scope="scope">
            <div class="text-ellipsis" :title="scope.row.user">{{scope.row.user.real_name}}<span v-if="scope.row.user.is_team">(队长)</span></div>
            <div class="text-ellipsis" :title="scope.row.user">{{scope.row.user.mobile}}</div>
          </template>
        </el-table-column>
         <el-table-column prop="unit.unit_name" label="单位名称" ></el-table-column>
        <el-table-column prop="group.unit_group_name" label="单位团队名称" v-if="task.type == 4" ></el-table-column>
        <el-table-column prop="total_step" label="累计步数" ></el-table-column>
        <!-- <el-table-column prop="points" label="积分" ></el-table-column> -->
        <el-table-column prop="create_time" label="添加时间" ></el-table-column>


      </el-table>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">返回</el-button>
    
    </div>
  </div>
</template>

<script>
import taskApi from '@/api/task.js';

export default {
  components: {

  },
  data() {
    return {
      task_id:'',
      /*横向表单数据模型*/
      searchForm: {
        search: "",
        unit_id:"",
        create_time: ''
      },
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,

      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      task:'',
      unitList:[],
    };
  },
  created() {
    this.task_id = this.$route.query.task_id;
    /*获取任务列表*/
    this.getTableList();
  },
  methods: {
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getTableList();
    },
    /*获取任务列表*/
    getTableList() {
      let self = this;
      let Params = this.searchForm;
      Params.page = self.curPage;
      Params.task_id = self.task_id;
      taskApi.rankList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.task = data.data.task;
          self.unitList= data.data.unitList;
        })
        .catch(error => {
          self.loading = false;
        });
    },


    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getTableList();
    },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }

  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/task/rank/index.vue